import { render, staticRenderFns } from "./questionresult.vue?vue&type=template&id=4d472c86"
import script from "./questionresult.vue?vue&type=script&lang=js"
export * from "./questionresult.vue?vue&type=script&lang=js"
import style0 from "./questionresult.vue?vue&type=style&index=0&id=4d472c86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports